module.exports = __webpack_public_path__ + "static/media/slide-1.bf88f4fb.png";